<sm-title-bar
  pageTitle="Admin posts"
  [showBackButton]="true"
  [headerCustomTemplate]="addButton"
>
  <ng-template #addButton>
    <button mat-flat-button color="accent" (click)="onCreateNewPost()">
      Create new
      <mat-icon class="material-icons-round" [inline]="true"
        >add_circle</mat-icon
      >
    </button>
  </ng-template>
</sm-title-bar>

<div *ngIf="isLoading" class="loader">
  <mat-spinner></mat-spinner>
</div>

<div
  *ngIf="!isLoading"
  class="row row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 g-4"
>
  <div class="col" *ngFor="let post of adminPostList">
    <sm-admin-post-card
      [postData]="post"
      (onOpenModel)="openModel($event)"
    ></sm-admin-post-card>
  </div>
</div>
<mat-paginator
  class="mt-4"
  [length]="totalData"
  [pageSize]="8"
  (page)="onPageChange($event)"
>
</mat-paginator>
